document.addEventListener('DOMContentLoaded', function () {
    const shareLinks = document.querySelectorAll('.share-link');

    if (shareLinks.length === 0) {
        return;
    }

    shareLinks.forEach((link) => {
        link.addEventListener('click', function (event) {
            event.preventDefault();

            const socialNetwork = this.getAttribute('data-socialnetwork');
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'socialClick',
                socialNetwork: socialNetwork,
            });

            const href = this.getAttribute('href');
            if (href) {
                window.open(href, '_blank', 'noopener,noreferrer');
            }
        });
    });
});